export const tokenStorageKey = import.meta.env.VITE_LOCAL_STORAGE_KEY
export const refreshTokenStorageKey = `${import.meta.env.VITE_LOCAL_STORAGE_KEY}_refresh`

// Access token
export function getToken(): string | null {
  return localStorage.getItem(tokenStorageKey)
}

export function setToken(token: string | null): void {
  if (token) {
    localStorage.setItem(tokenStorageKey, token)
  } else {
    localStorage.removeItem(tokenStorageKey)
  }
}

export function clearToken() {
  localStorage.removeItem(tokenStorageKey)
}

// Refresh token
export function getRefreshToken(): string | null {
  return localStorage.getItem(refreshTokenStorageKey)
}

export function setRefreshToken(token: string | null): void {
  if (token) {
    localStorage.setItem(refreshTokenStorageKey, token)
  } else {
    localStorage.removeItem(refreshTokenStorageKey)
  }
}

export function clearRefreshToken() {
  localStorage.removeItem(refreshTokenStorageKey)
}

// Clear all tokens (for logout)
export function clearAllTokens() {
  clearToken()
  clearRefreshToken()
}
